import React, { memo, useContext, useEffect, useState } from 'react';
import { Table, ActionIcon, Select, Pagination, LoadingOverlay } from '@mantine/core';
import { IoTrashOutline } from "react-icons/io5";
import { FaRegEdit } from "react-icons/fa";
import classes from "./TableMaterialSubType.module.css";
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../Customhooks/useFetch';
import { baseUrl } from '../../../Constants/constant';
import DeleterowData from '../../../CustomComponent/DeleteTableRow/DeleteTableRow.component';
import { useDisclosure } from '@mantine/hooks';
import { authContext } from '../../../context/AuthProvider.component';

function TableMaterialSubType({ editLink, search }: any) {
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);
    const [refresh, setRefresh] = useState<number>(0);
    const [selectedId, setSelectedId] = useState<number | null>(null);

    const { setError, inputRefresh }: any = useContext(authContext);
    const [confirmDeleteOpened, { open: openConfirmDelete, close: closeConfirmDelete }] = useDisclosure(false);
    const [successModalOpened, { open: openSuccessModal, close: closeSuccessModal }] = useDisclosure(false);
    const navigate = useNavigate();

    const token = localStorage.getItem("token");

    const {
        data: datalist,
        loading: listLoading,
        error: getlistError,
        fetchData: gettable,
    } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    });

    useEffect(() => {
        gettable(`${baseUrl}admin/raw-material-sub-types?page=${page}&limit=${limit}&search=${search}`);
    }, [page, limit, search, refresh]);

    useEffect(() => {
        if (getlistError) {
            setError(getlistError?.message)
        }
    }, [getlistError]);
      useEffect(() => {
        if (inputRefresh > 0) {
          setRefresh(inputRefresh);
        }
      }, [inputRefresh]);

    const handleClickEdit = (id: number) => {
        navigate(`${editLink}/${id}`);
    };
    const handleClickDelete = async (id: number) => {
        setSelectedId(id);
        openConfirmDelete();
    };
    const handleCloseSuccessModal = () => {
        setRefresh(prev =>  prev + 1);
        closeSuccessModal();
    };
    const rows = datalist?.data?.rows?.map((el: any) => (
        <Table.Tr key={el?.id}>
            <Table.Td>{el?.sub_name}</Table.Td>
            <Table.Td>{el?.Vertical?.vertical_name}</Table.Td>
            <Table.Td>{el?.RawMaterial?.material_name}</Table.Td>
            {/* <Table.Td>{el?.Factory?.factory_name}</Table.Td> */}
            <Table.Td>{el?.Process?.process_name}</Table.Td>
            <Table.Td>{el?.water_consumption} liter</Table.Td>
            <Table.Td>{el?.co2_embodiment} g</Table.Td>
            <Table.Td>{el?.source_name}</Table.Td>
            <Table.Td>{el?.source}</Table.Td>
            <Table.Td>{el?.description}</Table.Td>
            <Table.Td>{el?.DatabaseVersion?.db_version}</Table.Td>
            <Table.Td>
                <ActionIcon
                    color="#404040"
                    variant="subtle"
                    onClick={() => handleClickEdit(el.id)}
                >
                    <FaRegEdit size={16} />
                </ActionIcon>
                <ActionIcon
                    color="red"
                    variant="subtle"
                    onClick={() => handleClickDelete(el.id)}
                >
                    <IoTrashOutline size={16} />
                </ActionIcon>
            </Table.Td>
        </Table.Tr>
    ));

    const totalPages = Math.ceil((datalist?.data?.count || 0) / limit);
    return (
        <div style={{ padding: '20px 10px 20px 10px' }}>
            <LoadingOverlay
                            visible={listLoading}
                            zIndex={1000}
                            overlayProps={{
                                radius: 'sm',
                                blur: 2,
                                style: {
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%'
                                }
                            }}
                            loaderProps={{ color: '#404040', type: 'bars' }}
                        />

            {/* Error State */}
            {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>}

            {!listLoading && !getlistError && (
                <>
                    {/* Table */}
                    <Table.ScrollContainer minWidth={2000}>
                        <Table striped className={classes.customtable}>
                            <Table.Thead>
                                <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                                    <Table.Th>Sub Type Name</Table.Th>
                                    <Table.Th>Category Name</Table.Th>
                                    <Table.Th>Raw Material Name</Table.Th>
                                    {/* <Table.Th>Factory Name</Table.Th> */}
                                    <Table.Th>Process Name</Table.Th>
                                    <Table.Th>Water Consumption (liters)</Table.Th>
                                    <Table.Th>CO₂ Embodied per (g)</Table.Th>
                                    <Table.Th>Source Name</Table.Th>
                                    <Table.Th>Source</Table.Th>
                                    <Table.Th>Source Description</Table.Th>
                                    <Table.Th>Database Version</Table.Th>
                                    <Table.Th>Action</Table.Th>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                {datalist?.data?.rows?.length < 1 ? (
                                    <Table.Tr>
                                        <Table.Td colSpan={7} style={{ textAlign: 'center', fontSize: '17px' }}>No data Available </Table.Td>
                                    </Table.Tr>
                                ) : (
                                    rows
                                )}
                            </Table.Tbody>
                        </Table>
                    </Table.ScrollContainer>

                    {/* Pagination */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                        }}
                    >
                        <Select
                            data={[
                                { value: '5', label: '05 per page' },
                                { value: '10', label: '10 per page' },
                                { value: '20', label: '20 per page' },
                            ]}
                            value={limit.toString()}
                            onChange={(value) => setLimit(Number(value))}
                            style={{ width: '150px' }}
                        />
                        <Pagination
                            total={totalPages}
                            value={page}
                            onChange={setPage}
                            color="#404040"
                        />
                        <DeleterowData
                            isConfirmOpen={confirmDeleteOpened}
                            isSuccessOpen={successModalOpened}
                            closeConfirm={closeConfirmDelete}
                            closeSuccess={handleCloseSuccessModal}
                            selectedId={selectedId}
                            onDeleteSuccess={openSuccessModal}
                            url={'admin/raw-material-sub-types/delete/'}
                        />
                    </div>
                </>
            )}
        </div>
    );
}

export default memo(TableMaterialSubType);
